const MotionGlobalConfig = {};

export { MotionGlobalConfig };
//# sourceMappingURL=global-config.mjs.map
